module.exports = __webpack_public_path__ + "img/icon26.7104c52f.png";